import { TenantName } from "../../types/TenantName";
import { Tenant } from "./TenantService";

export type Currency = "€" | "CHF";

export type TenantConfig = { currency: Currency; validationPattern: [RegExp, number] };

export const DEFAULT_CURRENCY: Currency = "€";
export const DEFAULT_VALIDATION_PATTERN: [RegExp, number] = [/^([a-zA-Z]{4}\d{6}[a-zA-Z]{1}|\d{11})$/, 11];

export const TENANTS: Record<TenantName, Partial<TenantConfig>> = {
    [TenantName.DE_DID]: { validationPattern: [/^([a-zA-Z]{4}\d{6}[a-zA-Z]{1}|\d{11})$/, 11] },
    [TenantName.BE_EOS]: { validationPattern: [/^[0-9]{12}$/, 12] },
    [TenantName.ES_EOS]: { validationPattern: [/^[IRSU][0-9a-zA-Z]{12,24}$/, 25] },
    [TenantName.CH_EOS]: { currency: "CHF", validationPattern: [/^\d{9}$/, 9] },
    [TenantName.FR_EOS]: { validationPattern: [/^\d{3,12}$/, 12] },
    [TenantName.UDP_MOCK]: {},
};

export function getTenantConfigWithDefaults(name: TenantName): Tenant {
    const config = TENANTS[name];

    return {
        name,
        currency: DEFAULT_CURRENCY,
        validationPattern: DEFAULT_VALIDATION_PATTERN,
        ...config,
    };
}
